import { DEFAULT_LOOKUPS, LOOKUP_KINDS, type LookupKind } from './crm.js';

/**
 * وصف قوائم القيم للعرض.
 *
 * المفاتيح وقيمها المبدئية معرَّفة في crm.ts وتُعاد قراءتها من هناك لا
 * تُكرَّر: قائمتان لنفس الشيء تفترقان عند أول إضافة.
 *
 * الناقص كان الوصف وحده — ما هذه القائمة وأين تظهر. وهو ما يحتاجه من يقف
 * أمام سبع قوائم لا يعرف أثر تعديل أيٍّ منها.
 */

export interface LookupKindDef {
  key: LookupKind;
  label: string;
  description: string;
  /** أين تظهر — ليعرف المستخدم أثر التعديل قبل أن يجريه. */
  usedIn: string;
  defaults: readonly string[];
}

const META: Readonly<Record<LookupKind, Omit<LookupKindDef, 'key' | 'defaults'>>> = {
  leadSource: {
    label: 'مصادر العملاء المحتملين',
    description: 'من أين وصلك العميل.',
    usedIn: 'شاشة العميل المحتمل، وتقرير المصادر.',
  },
  industry: {
    label: 'الأنشطة والقطاعات',
    description: 'مجال عمل العميل.',
    usedIn: 'ملف العميل والعميل المحتمل.',
  },
  lostReason: {
    label: 'أسباب خسارة الصفقات',
    description: 'لماذا لم تُغلق الصفقة.',
    usedIn: 'إغلاق الصفقة، وتقرير أسباب الخسارة.',
  },
  callOutcome: {
    label: 'نتائج المكالمات',
    description: 'ما انتهت إليه المكالمة.',
    usedIn: 'تسجيل مكالمة في الأنشطة.',
  },
  paymentMethod: {
    label: 'طرق السداد',
    description: 'كيف يصلك المال.',
    usedIn: 'تسجيل التحصيلات.',
  },
  department: {
    label: 'الأقسام',
    description: 'أقسام الشركة الداخلية.',
    usedIn: 'ملفات الموظفين وكشوف الحضور.',
  },
  position: {
    label: 'المسمّيات الوظيفية',
    description: 'المناصب داخل الشركة.',
    usedIn: 'ملفات الموظفين والعملاء المحتملين.',
  },
};

export const LOOKUP_KIND_DEFS: readonly LookupKindDef[] = LOOKUP_KINDS.map((key) => ({
  key,
  ...META[key],
  defaults: DEFAULT_LOOKUPS[key],
}));

export const LOOKUP_KIND_MAP = Object.fromEntries(
  LOOKUP_KIND_DEFS.map((d) => [d.key, d]),
) as Readonly<Record<LookupKind, LookupKindDef>>;
